import { mapTo } from 'rxjs/operators';

import { FETCH_APPOINTMENT } from 'modules/appointmentInfo/actions/fetchAppointment';
import { SHOW_APPOINTMENT_INFO } from 'modules/queues/common/actions/appointmentInfo';
import { resubscribeServiceConfigUpdates } from 'modules/queues/common/actions/resubscribeServiceConfigUpdate';
import { FETCH_APPOINTMENTS, FETCH_MORE_APPOINTMENTS } from 'modules/queues/Schedule/actions/fetchAppointments';

import {
  ADD_APPOINTMENT_TO_LIST,
  REMOVE_APPOINTMENT_FROM_LIST,
  UPDATE_EXISTING_APPOINTMENT,
} from 'modules/queues/common/actions/appointmentsListActions';


export const resubscribeServiceConfigUpdatesEpic = (action$) =>
  action$
    .ofType(
      FETCH_APPOINTMENT.success,
      FETCH_APPOINTMENTS.success,
      FETCH_MORE_APPOINTMENTS.success,
      ADD_APPOINTMENT_TO_LIST,
      REMOVE_APPOINTMENT_FROM_LIST,
      UPDATE_EXISTING_APPOINTMENT,
      SHOW_APPOINTMENT_INFO,
    )
    .pipe(mapTo(resubscribeServiceConfigUpdates));
